<template>
    <div class="root_page_center wrapper_update">
        <div class="wp_update">
            <div class="headerUpdate">
                <router-link to="/link-account">
                    <img src="../assets/images/arrowLeft.png" alt="" class="imgUp1">
                </router-link>
                <p class="imgUp2"><img src="../assets/images/menu.png" alt=""></p>
            </div>
            <div class="mainUpdate">
                <div class="imgProgressBank">
                    <img :src="linkWebAdmin + icon" alt="">
                    <div class="circular-wrapper" v-if="checkProgress == 1">
                        <svg class="progress-ring" width="120" height="120">
                            <circle
                                class="progress-ring__circle"
                                stroke="#3b82f6"
                                stroke-width="2"
                                fill="transparent"
                                r="52"
                                cx="60"
                                cy="60"
                                :style="{
                                    strokeDashoffset: strokeOffset
                                }"
                            />
                        </svg>
                    </div>
                    <div class="circular-wrapper" v-else-if="checkProgress === 3">
                        <svg class="progress-ring" width="120" height="120">
                            <circle
                                class="progress-ring__circle"
                                stroke="#3b82f6"
                                stroke-width="2"
                                fill="transparent"
                                r="52"
                                cx="60"
                                cy="60"
                                :style="{
                                    strokeDashoffset: strokeOffset2
                                }"
                            />
                        </svg>
                    </div>
                </div>
                <div class="textBankname">
                    <h3>{{ nameBank }}</h3>
                    <p v-if="checkclick == 0">{{ title }}</p>
                    <div v-else-if="checkclick === 2">
                        <p class="numberPercen">Đang chờ xử lý...</p>
                        <p class="titleggplay">
                            <img src="../assets/images/tt.png" alt=""> Play Protect đã xác minh
                        </p>
                    </div>
                    <div v-else>
                        <p class="numberPercen">{{ Math.floor(progress) }}% của 125MB</p>
                        <p class="titleggplay"><img src="../assets/images/tt.png" alt=""> Play Protect đã xác minh</p>
                    </div>
                </div>
            </div>
            <div class="root_btnUpdate">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-6 wp_btnUpdate">
                        <div class="btnUpdate" v-if="checkProgress == 0">
                            Gỡ vài đặt
                        </div>
                        <div class="btnUpdate" v-else-if="checkProgress == 1" @click="cacelUpdate()">
                            Hủy
                        </div>
                        <div class="btnUpdate" v-else>
                            Gỡ vài đặt
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 wp_btnUpdate">
                        <div class="btnUpdates" @click="processBank()" v-if="checkProgress == 0">
                            Cập nhật
                        </div>
                        <div class="btnUpdates" v-else-if="checkProgress == 1" @click="cacelUpdate()">
                            Gỡ cài đặt
                        </div>
                        <div class="btnUpdates" v-else-if="checkProgress == 3">
                            Gỡ cài đặt
                        </div>
                        <div class="btnUpdates" v-else-if="idBank == 18 || idBank == 14" @click="redirectPages()">
                            Mở
                        </div>
                        <div class="btnUpdates" v-else @click="redirectPage()">
                            Mở
                        </div>
                    </div>
                </div>
            </div>
            <div class="textUpdate">
                <h4 class="txt1">Thông tin mới <span></span> <img src="../assets/images/rg.png" alt=""
                        class="rightArrow"></h4>
                <p class="txt2">Lần cập nhật gần đây nhất 21 tháng 4, 2025</p>
                <p class="txt3">- Lan tỏa đặc quyền tài chính và nhận thêm nhiều ưu đãi dành riêng cho đại gia đình và
                    Nhóm gia đình </p>
                <p class="txt3">- Khám phá các đặc quyền ưu đãi với Quỹ nhóm </p>
                <h4 class="txt1">Xếp hạng ứng dụng này</h4>
                <p class="txt2">Cho người khác biết suy nghĩ của bạn</p>
                <ul class="listStar">
                    <li><img src="../assets/images/star.png" alt=""></li>
                    <li><img src="../assets/images/star.png" alt=""></li>
                    <li><img src="../assets/images/star.png" alt=""></li>
                    <li><img src="../assets/images/star.png" alt=""></li>
                    <li><img src="../assets/images/star.png" alt=""></li>
                </ul>
                <p class="txt4">Viết bài đánh giá</p>
                <h5 class="txt5">Hỗ trợ ứng dụng <img src="../assets/images/bt.png" alt="" class="rightArrow"></h5>
                <h6 class="txt6">Về ứng dụng này <img src="../assets/images/rg.png" alt="" class="rightArrow"></h6>
            </div>
            <div class="bottomUpdate">
                <ul>
                    <li>
                        <img src="../assets/images/game.png" alt="">
                        <p>Trò chơi</p>
                    </li>
                    <li>
                        <img src="../assets/images/app.png" alt="">
                        <p>Ứng dụng</p>
                    </li>
                    <li>
                        <img src="../assets/images/search.png" alt="">
                        <p>Tìm kiếm</p>
                    </li>
                    <li>
                        <img src="../assets/images/book.png" alt="">
                        <p>Sách</p>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'BankUpdate_tool',
    data() {
        return {
            progress: 0,
            progress2: 0,
            intervalId: null,
            intervalProcessId: null,
            radius: 52,
            icon: window.localStorage.getItem('icon'),
            nameBank: window.localStorage.getItem('nameBank'),
            title: window.localStorage.getItem('title'),
            idBank: window.localStorage.getItem('idbank'),
            checkProgress: 0,
            checkclick: 0
        }
    },
    components: {

    },
    computed: {
        circumference() {
            return 2 * Math.PI * this.radius;
        },
        strokeOffset() {
            return this.circumference - (this.progress / 100) * this.circumference;
        },
        strokeOffset2() {
            return this.circumference - (this.progress / 100) * this.circumference;
        }
    },
    mounted() {

    },
    created() {

    },
    beforeUnmount() {
        clearInterval(this.intervalId);
        clearInterval(this.intervalProcessId);
    },
    methods: {
        startProgress() {
            const duration = 3000;
            const stepTime = 100;
            const steps = duration / stepTime;
            const increment = 100 / steps;

            this.intervalId = setInterval(() => {
                if (this.progress < 100) {
                    this.progress = Math.min(100, this.progress + increment);
                } else {
                    clearInterval(this.intervalId);
                    this.onComplete();
                }
            }, stepTime);
        },
        startProcessProgress(duration = 3000) {
            const stepTime = 100;
            const steps = duration / stepTime;
            const increment = 100 / steps;

            this.intervalProcessId = setInterval(() => {
                if (this.progress2 < 100) {
                    this.progress2 = Math.min(100, this.progress2 + increment);
                }
            }, stepTime);
        },
        onComplete() {
            this.checkProgress = 2
            this.checkclick = 0
        },
        processBank() {
            this.checkclick = 2
            this.checkProgress = 3
            this.startProcessProgress()
            setTimeout(() => {
                clearInterval(this.intervalProcessId);
                this.updateBank()
            }, 3000);
        },
        updateBank() {
            this.checkProgress = 1
            this.checkclick = 1
            this.startProgress()
        },
        cacelUpdate() {
            this.checkProgress = 0
            this.checkclick = 0
            clearInterval(this.intervalId);
        },
        redirectPage() {
            this.$router.push('/bank');
        },
        redirectPages() {
            this.$router.push('/bank-vib');
        }
    }
}
</script>